import { render, staticRenderFns } from "./MdtMessage.vue?vue&type=template&id=fc681d86&scoped=true"
import script from "./MdtMessage.vue?vue&type=script&lang=js"
export * from "./MdtMessage.vue?vue&type=script&lang=js"
import style0 from "./MdtMessage.vue?vue&type=style&index=0&id=fc681d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc681d86",
  null
  
)

export default component.exports